/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './legalAgent.css';

function LegalAgent() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSd06Rq9cSWcz7V11C0kHBqLW78KmoJxYH_4RsihtTjhvb70YQ/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">Legal Assistant Agent</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product, designed specifically for legal advisors who are looking to increase website conversions, lead the path in legal AI innovation, and stand out  by integratating AI-powered features into their website & digital strategy.
            </p>

            <p>
              To Demo the product, form must be submitted. Then the assistant will generate a personalized response based on the information you provided and send it directly to your email.
              <strong> Please enter the email address where youd like to receive this information.</strong>
            </p>

            <p>
              <i>
                *Each agents logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, youre instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to request history.
              </i>
            </p>

            <p>
              <strong>NOTE: </strong>
              If youd like to learn more on how to offer this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer"> Calendly.</a>
              <div>
                <br />
                <a href="https://www.loom.com/share/6be7548930ca4cbb979a540ba3f0a7d9" target="_blank" rel="noopener noreferrer">
                  Watch the quick explainer video.
                </a>
              </div>
            </p>
            <p><strong className="form-intro-warning">Important: This form response is for informational DEMO purposes only and should not be used without guidance from a qualified professional.</strong></p>
          </div>
          <div className="required-note">
            <span className="required-symbol">*</span>
            indicates required field
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>
            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.1185935516"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* Jurisdiction Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="jurisdiction"
                  name="entry.1370155380"
                  required
                  className="form-input"
                  placeholder="National"
                />
                <label htmlFor="jurisdiction" className="select-label required">
                  Jurisdiction
                </label>
              </div>
            </div>

            {/* State Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="state"
                  name="entry.193755669"
                  className="form-input"
                  placeholder="Its national matter."
                />
                <label htmlFor="state" className="select-label required">
                  State:
                </label>
              </div>
            </div>

            {/* Situation (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="situation"
                  name="entry.753574077"
                  required
                  className="form-textarea"
                  placeholder="Ex.: I received a notice from the IRS and don’t know what to do."
                  rows="4"
                />
                <label htmlFor="situation" className="select-label required">
                  Situation
                </label>
              </div>
            </div>

            {/* Outcome (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="outcome"
                  name="entry.238467193"
                  required
                  className="form-textarea"
                  placeholder="I want to understand what the IRS notice means and what steps I need to take to respond properly to avoid getting penalized."
                  rows="4"
                />
                <label htmlFor="outcome" className="select-label required">
                  Expected outcome
                </label>
              </div>
            </div>

            {/* Urgent Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="urgent"
                  name="entry.304529255"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select urgency</option>
                  <option value="Urgent">Urgent</option>
                  <option value="30 days">30 days</option>
                  <option value="Not urgent">Not Urgent</option>
                </select>
                <label htmlFor="urgent" className="select-label required">
                  Urgency
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LegalAgent;
